import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useAppTheme } from '../../theme/ThemeContext';
import IconCircleButton from './IconCircleButton';

type ThemeToggleProps = {
  size?: number;
  variant?: 'outlined' | 'ghost' | 'elevated';
  style?: StyleProp<ViewStyle>;
};

/** Sun / moon button switching between light and dark mode. */
export default function ThemeToggle({ size = 40, variant = 'outlined', style }: ThemeToggleProps) {
  const { isDark, toggle } = useAppTheme();
  return (
    <IconCircleButton
      icon={isDark ? 'white-balance-sunny' : 'weather-night'}
      onPress={toggle}
      accessibilityLabel={isDark ? 'Passer en mode jour' : 'Passer en mode nuit'}
      size={size}
      variant={variant}
      style={style}
    />
  );
}
